// Convert snake_case or camelCase to Title Case
export const formatColumnName = (name: string): string => {
  return name
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .trim()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// Format numbers with appropriate decimal places
export const formatNumber = (
  value: any,
  decimals: number = 2,
  addCommas: boolean = false
): string => {
  if (value === null || value === undefined) return "-";

  const num = typeof value === "string" ? parseFloat(value) : Number(value);

  if (isNaN(num)) return String(value);

  // For non-currency numbers, don't add commas unless explicitly requested
  if (!addCommas) {
    return num.toFixed(decimals);
  }

  // For whole numbers, don't show decimals
  if (Number.isInteger(num) && decimals === 2) {
    return num.toLocaleString();
  }

  return num.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
};

// Format cell value based on column type
export const formatCellValue = (
  value: any,
  columnName: string,
  isCurrency: boolean = false
): string => {
  if (value === null || value === undefined) return "-";

  const stringValue = String(value);

  console.log("stringValue", stringValue);
  console.log("columnName", columnName);

  // Check if it's a currency column
  if (isCurrency) {
    const num = typeof value === "string" ? parseFloat(value) : Number(value);
    if (!isNaN(num)) {
      return "$" + formatNumber(num, 2, true);
    }
  }

  // Check if it's a numeric value and has decimals and is not a currency column
  if (
    !isNaN(parseFloat(stringValue)) &&
    isFinite(Number(stringValue)) &&
    stringValue.includes(".")
  ) {
    // For non-currency numbers, don't add commas
    return formatNumber(value, 2, false);
  }

  // Check if it's a numeric value and has no decimals and is not a currency column
  if (!isNaN(parseFloat(stringValue)) && isFinite(Number(stringValue))) {
    return formatNumber(value, 0, false);
  }

  // Check if it's a date
  if (stringValue.match(/^\d{4}-\d{2}-\d{2}/)) {
    try {
      const date = new Date(stringValue);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString();
      }
    } catch (e) {
      // Not a valid date, return as is
    }
  }

  return stringValue;
};

// Check if a column name represents monetary data
export const isMonetaryColumn = (columnName: string): boolean => {
  const lowerName = columnName.toLowerCase();
  const monetaryKeywords = [
    "price",
    "cost",
    "amount",
    "revenue",
    "profit",
    "expense",
    "fee",
    "charge",
    "payment",
    "salary",
    "wage",
    "income",
    "total",
    "subtotal",
    "tax",
    "discount",
    "balance",
    "budget",
    "value",
    "rate",
    "premium",
    "commission",
  ];

  return monetaryKeywords.some((keyword) => lowerName.includes(keyword));
};
